import React from 'react';
import MobilePricingWidget from '@rentivo/gatsby-core/src/containers/PricingProvider/components/MobilePricingWidget/component';

MobilePricingWidget.defaultProps = {

};

export default MobilePricingWidget;
